(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[204],{

/***/ "+nt3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXTERNAL MODULE: /opt/webapp/node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__("cxan");

// EXTERNAL MODULE: /opt/webapp/node_modules/react/index.js
var react = __webpack_require__("ERkP");
var react_default = /*#__PURE__*/__webpack_require__.n(react);

// EXTERNAL MODULE: ./src/client/components/widgets/hero/Hero.jsx
var Hero = __webpack_require__("2B1m");

// CONCATENATED MODULE: ./src/client/components/lines/highlight-line/HighlightLine.jsx

var __jsx = react_default.a.createElement;


var HighlightLine_HighlightLine = function HighlightLine(props) {
  return __jsx(Hero["a" /* Hero */], Object(esm_extends["a" /* default */])({}, props, {
    className: "Line Line-Highlight",
    hLevel: 2,
    size: props.size === 'small' ? 'highlightSmall' : 'highlight',
    trackingData: {
      actionGA: 'highlight'
    }
  }));
};
// CONCATENATED MODULE: ./src/client/cms/toolkit/highlight/descriptor.js

/* harmony default export */ var descriptor = __webpack_exports__["default"] = (HighlightLine_HighlightLine);

/***/ })

}]);